module.exports = __webpack_public_path__ + "./img/bug-fix.svg";